import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SimpleApi } from '@core/api/simple.api';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { OpkraevningsListerService } from '../opkraevningslister.service';

@Component({
  selector: 'app-opkraevningslister-result',
  imports: [
    TableRowDirective,
    TableModule,
    DatePipe,
    KeepScrollPositionDirective,
  ],
  templateUrl: './opkraevningslister-result.component.html',
  styleUrl: './opkraevningslister-result.component.css',
})
export class OpkraevningsListerResultComponent {
  simpleApi = inject(SimpleApi);
  opkraevningsListerService = inject(OpkraevningsListerService);
  data = this.opkraevningsListerService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.opkraevningsListerService.selectOpkraevningsListeResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.opkraevningsListerService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }

  async exportData(event: MouseEvent, opkraevningsListeId: number) {
    event.stopPropagation();
    this.opkraevningsListerService.exportData(opkraevningsListeId);
  }
}
